"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const axios_1 = __importDefault(require("axios"));
const content_1 = require("@/Redux/Actions/content");
const react_redux_1 = require("react-redux");
const InterceptFetch = ({ enableProgressBar, disableProgressBar }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const loaded = (0, react_redux_1.useSelector)((state) => state.content.loaded);
    axios_1.default.interceptors.request.use(function (config) {
        if (config.url.includes('GetContent')) {
            enableProgressBar();
        }
        return config;
    }, function (error) {
        return Promise.reject(error);
    });
    axios_1.default.interceptors.response.use(function (response) {
        if (response.config.url.includes('GetContent')) {
            disableProgressBar();
        }
        return response;
    }, function (error) {
        if (error.config && error.config.url.includes('GetContent')) {
            disableProgressBar();
        }
        return Promise.reject(error);
    });
    const { fetch: originalFetch } = window;
    window.fetch = (...args) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const [resource, config] = args;
        if (typeof resource === 'string' && resource.includes('contentUrl')) {
            enableProgressBar();
            dispatch((0, content_1.setLoaded)(false));
        }
        if (typeof resource === 'object' && ((_a = resource === null || resource === void 0 ? void 0 : resource.url) === null || _a === void 0 ? void 0 : _a.includes('contentUrl'))) {
            enableProgressBar();
            dispatch((0, content_1.setLoaded)(false));
        }
        try {
            const response = yield originalFetch(resource, config);
            disableProgressBar();
            if (!loaded) {
                dispatch((0, content_1.setLoaded)(true));
            }
            return response;
        }
        catch (error) {
            console.log(error);
        }
    });
    return react_1.default.createElement(react_1.default.Fragment, null);
};
exports.default = InterceptFetch;
